'use client';
import { tab, getTabbableItems } from './tabbable';
// TODO: move this to hooks
export const handleSelectKeyDown = (event) => {
    if (event.key === 'ArrowDown') {
        event.preventDefault();
        event.currentTarget.dispatchEvent(new MouseEvent('click', {
            bubbles: true
        }));
    }
};
// TODO: this is for the future, too many questions to answer:
// - should we auto open the dropdown when the user types/tabs?
export const handleSelectDropdownOpen = (menuRoot) => {
    const query = menuRoot.dataset.multiselect ? '[aria-checked=true]' : '[aria-selected=true]';
    const selectedItem = menuRoot.querySelector(query);
    if (selectedItem) {
        selectedItem.focus();
        return;
    }
    getTabbableItems(menuRoot, false)[0]?.focus();
};
export const handleSelectDropdownClose = (button) => {
    if (button) {
        button.removeAttribute('aria-activedescendant');
        button.focus();
    }
};
export const handleSelectDropdownFocus = (event, el) => {
    if (el?.getAttribute('aria-expanded') === 'true') {
        el.setAttribute('aria-activedescendant', event.target.id);
    }
};
export const handleSelectDropdownKeyDown = (event, closeDropdown) => {
    switch (event.key) {
        // TODO: future, test with screen reader
        // case '/':
        //     if (event.ctrlKey || event.metaKey) {
        //         event.preventDefault();
        //         event.currentTarget.querySelector<HTMLInputElement>('[placeholder="Search"]')?.focus();
        //     }
        //     break;
        case 'Home':
            event.preventDefault();
            event.stopPropagation();
            getTabbableItems(event.currentTarget).at(0)?.focus();
            break;
        case 'End':
            event.preventDefault();
            event.stopPropagation();
            getTabbableItems(event.currentTarget).at(-1)?.focus();
            break;
        case 'ArrowUp':
            event.preventDefault();
            tab('backward', event.currentTarget);
            break;
        case 'ArrowDown':
            event.preventDefault();
            tab('forward', event.currentTarget);
            break;
        case 'Tab':
        case 'Escape':
            event.preventDefault();
            event.stopPropagation();
            closeDropdown();
            break;
        default:
            break;
    }
};
export const handleSearchClear = (searchInput) => {
    searchInput?.focus();
};
